import { ProfileEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const changePassword = async (data: any): Promise<any> =>
  APIManager.sendPatch(ProfileEnds.CHANGE_PASSWORD, data, true, {}, {}, axios);

export const ProfileService = {
  changePassword,
};
